import React from 'react';
import { Globe, Lock, Layers } from 'lucide-react';

export const CHANNEL_FILTER_TABS = [
  { value: 'all', label: 'All channels', icon: Layers },
  { value: 'internal', label: 'Internal', icon: Globe },
  { value: 'external', label: 'External', icon: Lock },
];

/**
 * Compact Internal / External / All filter for Insights pages.
 */
const ChannelFilterTabs = ({ value = 'all', onChange, className = '', ariaLabel = 'Channel filter' }) => {
  return (
    <div
      className={`inline-flex flex-wrap rounded-xl border border-border bg-gray-100 p-1 ${className}`.trim()}
      role="tablist"
      aria-label={ariaLabel}
    >
      {CHANNEL_FILTER_TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = value === tab.value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(tab.value)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-2 text-xs font-medium transition-all sm:text-sm ${
              isActive
                ? 'bg-surface text-ink shadow-sm'
                : 'text-ink-secondary hover:text-gray-900'
            }`}
          >
            <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ChannelFilterTabs;
